import { useLayoutEffect, useState } from 'react';
import { Router as RouterContext } from 'react-router';

import type { BrowserHistory } from 'history';
import type { ReactNode } from 'react';

import LastLocationContextProvider from '@/contexts/providers/lastLocation';

interface RouterProps {
  children: ReactNode;
  history: BrowserHistory;
}

export default function Router({ children, history }: RouterProps) {
  const [state, setState] = useState(function initialState() {
    return { action: history.action, location: history.location };
  });

  useLayoutEffect(
    function effect() {
      return history.listen((update) => {
        setState(update);

        if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
          window.fbq('track', 'PageView');
        }
      });
    },
    [history],
  );

  return (
    <RouterContext location={state.location} navigationType={state.action} navigator={history}>
      <LastLocationContextProvider>
        {children}
      </LastLocationContextProvider>
    </RouterContext>
  );
}
